module.exports = __webpack_public_path__ + "img/emotion@2x.86ab042.jpg";